import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCaretDown, faCaretRight, faPlusCircle, faMinusCircle
} from "@fortawesome/free-solid-svg-icons";
import { CompetitionFromStore } from 'helpers/utils'
import TteTeamStats from 'components/sports/tte/views/TteTeamStats'
import TtePlayerStats from "components/sports/tte/views/TtePlayerStats";
import Label from "components/general/Label";
import { isFinishedStatus, isLiveStatus, isStartListStatus } from "helpers/status";

function ExpandableData({ data, results, resultStatus }) {
    const [hideable, setHideable] = useState("d-none");
    const competition = CompetitionFromStore();
    const iconOpen = competition === 'EG2023' ? faMinusCircle : faCaretDown;
    const iconClose = competition === 'EG2023' ? faPlusCircle : faCaretRight;

    const isTeamAndMain = data?.results?.eventUnitCode.endsWith('0')

    const isTeam = (data?.results?.items?.find(x => x !== undefined)?.statsItems !== undefined)

    const toggleExpandable = (e) => {
        setHideable((oldValue) => { return oldValue === 'd-none' ? '' : 'd-none' })
    }

    let isIrm = data?.results?.items?.some(item => item.resultIrm)
    let isDisabled
    isDisabled = isStartListStatus(resultStatus) ? true : isIrm ? true : false

    return (
        <>  <div className="d-flex justify-content-end">
            <button onClick={toggleExpandable} disabled={isDisabled}>
                {isTeamAndMain ? <Label data={'HeaderTeamMatchStats'} sport={'TTE'}/> : <Label data={'HeaderMatchStatistics'} />}&nbsp;
                {hideable === 'd-none'
                    ? <FontAwesomeIcon className="font-icon" icon={iconClose} />
                    : <FontAwesomeIcon className="font-icon" icon={iconOpen} />}</button></div>
            <div className={hideable}>
                <TteTeamStats data={data} results={results} isTeamAndMain={isTeamAndMain} />
                <TtePlayerStats data={data} results={results} isTeamAndMain={isTeamAndMain} isTeam={isTeam}/>
            </div>
        </>
    )
}

export default ExpandableData;